module.exports = __webpack_public_path__ + "static/media/key.9d7977f2.png";